import { makeAutoObservable, runInAction } from 'mobx';

import type { Main } from '@app/store';

import type { AgentBranch } from '../types/agentBranch.types';

export class DictionariesStore {
  private mainStore: Main;
  // AgentBranch
  agentBranchDictionary?: AgentBranch[];
  isAgentBranchDictionaryLoaded?: boolean;

  constructor(mainStore: Main) {
    this.mainStore = mainStore;
    makeAutoObservable(this);
  }

  setAgentBranchDictionary = (dictionary: AgentBranch[]) => {
    runInAction(() => {
      this.agentBranchDictionary = dictionary;
      this.isAgentBranchDictionaryLoaded = true;
    });
  };

  reset() {
    runInAction(() => {
      this.agentBranchDictionary = undefined;
    });
  }
}
